import React, { useEffect, useState } from "react";
import { postCirugiaEntidadAseguradora, postContratosDeUnUser } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import ModalListaDeSeleccionContratosXEmpresa from "./ModalListaDeSeleccionContratosXEmpresa";
import TablaEntidadAseguradora from "./TablaEntidadAseguradora";

const ModalEntidadAseguradora = ({
  setModalOnCirugiaEntidadAseguradora,
  setChoiceCirugiaEntidadAseguradora,
  nombre,
  tipoDocumento,
  numeroDocumento,
  passDataEntidadAseguradora
}) => {
  const [userData, setUserData] = useState([]);
  //const [activo, setActivo] = useState("");
  //const [estado, setEstado] = useState("");
  const [loading, setLoading] = useState(false);
  const [
    modalOnListadeSeleccionContratosXEmpresa,
    setmodalOnListadeSeleccionContratosXEmpresa,
  ] = useState(false);
  const [actualizarContratos, setactualizarContratos]=useState([])

  const passActualizar=(data)=>{
    setactualizarContratos(data)
  }

  const handleOnclickSeleccionContratosXEmpresa = () => {
    setmodalOnListadeSeleccionContratosXEmpresa(true);
  };

  const handleCancelarClick = () => {
    setModalOnCirugiaEntidadAseguradora(false);
    setChoiceCirugiaEntidadAseguradora(false);
  };

  const passDataEA=(data)=>{
    passDataEntidadAseguradora(data)
    setModalOnCirugiaEntidadAseguradora(false);
    setChoiceCirugiaEntidadAseguradora(false);
  }

  const handleOnsubmitBuscar = (e) => {
    e.preventDefault();
    const body = {
      MPCedu: numeroDocumento,
      MPTDoc: tipoDocumento,
      MENNIT: e.target.nit.value,
      MENOMB: e.target.contrato.value,
      //varMEestado: '0',
      //varMPstatus:'A'
    };
    postContratosDeUnUser(body).then((res) => {
      //console.log(res.data,"Entodad uno")
      setLoading(true);
      setUserData(res.data);
      
    });
  };

  useEffect(() => {
    
    const body={
      MPCedu:numeroDocumento,
      MPTDoc:tipoDocumento,
      MENNIT:'',
      //varMEestado: '0',
      //varMPstatus:'A',
      MENOMB:''
  }
    // postCirugiaEntidadAseguradora(body).then((res) => {
    //   //console.log(res.data,"Entodad uno")
    //   setLoading(true);
    //   setUserData(res.data);
     
    // });
    postContratosDeUnUser(body).then((res)=>{
      setLoading(true);
      setUserData(res.data);
      //console.log(res.data,'dataCONTRATO')
    })
  }, [actualizarContratos]);
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
              <h5
                className="text-xl font-medium leading-normal text-white "
                id="exampleModalScrollableLabel"
              >
                Lista de Selección Empresa X Usuario
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative px-1">
              <div className="flex py-2 text-left">
                <div className="w-1/5  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    N° Documento
                  </label>
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    //defaultValue={dataUser.HISCKEY}
                    disabled={true}
                    defaultValue={numeroDocumento}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/5  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Tipo Documento
                  </label>
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    //defaultValue={dataUser.MPTDoc}
                    disabled={true}
                    defaultValue={tipoDocumento}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-3/5  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Nombre Paciente
                  </label>
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    //defaultValue={dataUser.MPNOMC}
                    disabled={true}
                    defaultValue={nombre}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
              <form onSubmit={handleOnsubmitBuscar}>
                <div className="flex  text-left">
                  {/* <div className="w-2/5  px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Contrato
                    </label>
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={dataUser.HISCKEY}
                      autoComplete="off"
                      type="text"
                      name="contrato"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div> */}
                  <div className="w-3/5  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Contrato
                    </label>
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={dataUser.MPTDoc}
                      autoComplete="off"
                      name="nit"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>

                  <div className="w-3/5  px-4">
                    <label className="form-label block mb-2 text-gray-900 font-medium pt-6">
                      
                    </label>
                    <button
                      type="submit"
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      buscar
                    </button>
                  </div>
                </div>
              </form>
              <div className="flex flex-col ">
                <div className="overflow-x-auto ">
                  <div className="py-2 inline-block min-w-full sm:px-1 ">
                    <div className="overflow-hidden ">
                      <table className="min-w-full text-center ">
                        <thead className="border-b bg-gray-200">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Estado
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              N.I.T
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tipo Contrato
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Contrato
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tipo Afiliado
                            </th>
                            
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              A = Activo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod. Reg
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Pabellón
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            userData.map((item, index) => (
                              <TablaEntidadAseguradora
                                item={item}
                                key={index}
                                passDataEA={passDataEA}
                              />
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>
                                <Loading />
                              </td>
                            </tr>
                          )}
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-t border-gray-200 rounded-t-md ">
              <div className="text-right">
                <button
                  type="button"
                  onClick={handleOnclickSeleccionContratosXEmpresa}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Lista de selección contratos X empresa
                </button>
              </div>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
      {modalOnListadeSeleccionContratosXEmpresa ? (
        <ModalListaDeSeleccionContratosXEmpresa
          setmodalOnListadeSeleccionContratosXEmpresa={
            setmodalOnListadeSeleccionContratosXEmpresa
          }
          tipoDocumento={tipoDocumento}
          nombre={nombre}
          numeroDocumento={numeroDocumento}
          passActualizar={passActualizar}
        />
      ) : null}
    </>
  );
};

export default ModalEntidadAseguradora;
